import { FC, useEffect } from "react";

import { CreateOrganization } from "@clerk/clerk-react";
import SettingsTopBar from "./SettingsTopBar";

const CreateOrganizationPage: FC = () => {
  return (
    <div className="flex flex-col h-full bg-white">
      <SettingsTopBar title="Create Organization" />
      <div className="flex-1 overflow-auto w-full p-4 flex flex-col items-center justify-center">
        <div className="mb-6 p-4 bg-gray-50 border border-gray-200 rounded-md max-w-md w-full">
          <h2 className="text-lg font-medium text-gray-800 mb-2">Create Your Organization</h2>
          <p className="text-gray-700">
            You need to create an organization to continue using the application.
            Organizations help you manage projects and collaborate with team members.
          </p>
        </div>
        <div className="max-w-md w-full">
          <CreateOrganization
            path="/create-org"
            routing="path"
            afterCreateOrganizationUrl="/dashboard"
          />
        </div>
      </div>
    </div>
  );
};

export default CreateOrganizationPage; 